import React, { useState, useEffect, useContext } from "react";
import LZString from "lz-string";
import { QuizShareCard } from "./quiz-share-card";
import { cn } from "../../../lib/helpers";
import { SiteContext } from "../../global/site-context";
import pipelineHeroQuizData from "./pipeline-hero-quiz.json";

// Quiz Share Section
export const QuizShare = () => {
  const [shareData, setShareData] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const site = useContext(SiteContext);

  // Default descriptions for each archetype
  const defaultDescriptions = {
    oracle: "See full humans, not fractured records. Pinpoint top prospects with person-level identity and AI waterfall enrichment.",
    striker: "Spot the signal and strike immediately. Move when it matters most with prioritized plays and real-time alerts.",
    resonator: "Don't choose between speed and quality—get both. Scale context-rich, hyper-relevant outreach across every touchpoint."
  };

  // Try to match archetype when no share data is present
  const archetype = pipelineHeroQuizData.archetypes?.[site?.doc.slug.current.slice(5)];
  const pathMatchData = archetype ? {
    archetype: archetype.name,
    resolvedArchetype: {
      name: archetype.name,
      subtitle: archetype.subtitle,
      borderColor: archetype.borderColor,
      squadImage: archetype.squadImage,
      powerIcon: archetype.powerIcon,
    },
    org: {
      facts: {
        name: null,
      }
    },
    dept: null,
    persona: null,
    cta: null,
    content: { share: defaultDescriptions[archetype.id] || `You are ${archetype.name}, someone who excels at driving results through focused action and strategic thinking.` }
  } : null;

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const shareParam = urlParams.get('share');
      if (shareParam) {
        try {
          // Use LZString decompression (matches the compression method)
          const jsonString = LZString.decompressFromEncodedURIComponent(shareParam);
          if (jsonString) {
            const decodedData = JSON.parse(jsonString);
            console.log('Successfully decompressed and decoded share data:', decodedData);
            console.log('Compressed length:', shareParam.length);
            console.log('Decompressed length:', jsonString.length);
            setShareData(decodedData);
            setShowResults(true);
          } else {
            throw new Error('Decompression returned null - invalid compressed data');
          }
        } catch (error) {
          console.error('Error decompressing share data:', error);
          console.log('Share parameter:', shareParam);
          console.log('Share parameter length:', shareParam.length);
        }
      }
    }
  }, []);

  const hasCardData = (showResults && shareData) || pathMatchData;

  return (
    <div className="max-w-5xl mx-4 sm:mx-auto mt-12 md:mt-0">
      <div className={cn(
        "grid grid-cols-1 gap-8 md:gap-12 lg:gap-20 text-white",
        hasCardData && "lg:grid-cols-2"
      )}>
        {/* LEFT COLUMN - Headline & CTA */}
        <div className="flex flex-col justify-center text-center lg:text-left rounded-xl font-superhero">
          <div className="text-7xl font-superhero mb-4">
            Unlock your secret superhero identity!
          </div>
          <div className="text-xl lg:text-2xl text-white/80 mx-4 lg:mx-0">
            Take the quiz to discover your superpowers—and the powers you stand to gain…
          </div>
          <a
            href="/hero/#quiz"
            className="mt-8 self-center lg:self-start bg-green-emerald text-black text-2xl px-8 py-3 rounded-xl font-superhero-bold transform scale-100 hover:scale-105 transition-size duration-200"
            style={{ boxShadow: '1px 1px 34px 4px rgba(34, 216, 153, 0.25)' }}
          >
            Take the Quiz
          </a>
        </div>
        {/* RIGHT COLUMN - Super Hero Card */}
        {hasCardData && (
          <QuizShareCard data={showResults && shareData ? shareData : pathMatchData} />
        )}
      </div>
    </div>
  );
};
